// 新建任务页面
import React from "react";
import { Button } from "antd";
import { updatePanelsInfo } from "@/state/action/comAction";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// 样式
import "./index.styl";
import exportIcon from "@/assets/img/taskManage/export-icon.png";
@connect((state) => state, { updatePanelsInfo })
class TaskBuildStep3 extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.cfgChangeTaskBuild;
    this.state = {
      fileName: "",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 返回任务管理
  backTaskManagement = () => {
    const panesInfo = this.props.panelsInfo;
    const activeKey = "0503";
    const openPanels = panesInfo.openPanels.filter(
      (item) => item.key !== "0503" && item.key !== "taskBuildStep",
    );
    this.context.store.dispatch(updatePanelsInfo(openPanels, activeKey));
    this.props.addTab({
      key: "0503",
      titleText: "任务管理",
    });
  };

  render() {
    const content = (
      <div className="step3-content">
        <div className="inner-part">
          <img alt="" src={exportIcon} className="task-icon-pic" />
          <div className="export-result">批量修改结束，返回查看任务结果</div>
          <div className="btn-group">
            <Button type="primary" onClick={this.backTaskManagement}>
              返回任务管理
            </Button>
          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(TaskBuildStep3);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskBuildStep3.js